import React from 'react';
import { Head } from '@ecommerce/nest-ssr/components';
import { useSelector } from '@ecommerce/nest-ssr/common';
import { OffersState, SortType } from '../../../../reducers/offers';
import { offersSort } from 'helpers/offers-sort';

const MetaTagsProduct: React.FC<{
    productId: number;
    producrName: string;
    offersCount: number;
    categoryName: string;
    categoryDepartamentName: string;
    categorySubdepartamentName: string;
}> = ({
    productId,
    producrName,
    offersCount,
    categoryName,
    categoryDepartamentName,
    categorySubdepartamentName
}) => {
    const offersFinal = useSelector((state: { offers: OffersState; }) => [...state.offers.items]).sort(offersSort(SortType.Price));
    const price = offersCount === 0 ? 0 : offersFinal[0].price;

    return (
        <Head>
            <meta property="product:availability" content={offersCount === 0 ? 'oos' : 'instock'}/>
            <meta property="product:brand" content={producrName}/>
            <meta
                property="product:category"
                content={`${categoryName} > ${categorySubdepartamentName} > ${categoryDepartamentName}`}
            />
            <meta property="product:price:amount" content={`${price}`}/>
            <meta property="product:price:currency" content="PLN"/>
            <meta property="product:retailer_item_id" content={`${productId}`}/>
        </Head>
    );
};

export default MetaTagsProduct;
